import { useState } from "react";
import { Eye, EyeOff, KeyRound, LogOut, ShieldCheck, X } from "lucide-react";
import { api } from "@/lib/api";

export const ChangePassword = ({ onDone, onLogout, forced = true, onClose }) => {
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const fields = [
    { key: "old_password", label: forced ? "Kata sandi sementara" : "Kata sandi saat ini", testid: "old-password-input", ph: forced ? "Kata sandi dari administrator" : "Kata sandi Anda sekarang" },
    { key: "new_password", label: "Kata sandi baru", testid: "new-password-input", ph: "Minimal 8 karakter" },
    { key: "confirm", label: "Ulangi kata sandi baru", testid: "confirm-password-input", ph: "Ketik ulang kata sandi baru" },
  ];
  const submit = async () => {
    if (form.new_password.length < 8) return setError("Kata sandi baru minimal 8 karakter");
    if (form.new_password !== form.confirm) return setError("Konfirmasi kata sandi tidak sama");
    setSaving(true); setError("");
    try {
      await api("/auth/change-password", { method: "POST", body: JSON.stringify({ old_password: form.old_password, new_password: form.new_password }) });
      onDone();
    } catch (e) { setError(e.message); }
    setSaving(false);
  };
  return (
    <div className="modal-overlay force-pass" data-testid="change-password-modal" onClick={forced ? undefined : onClose}>
      <div className="modal-panel pw-panel" onClick={(e) => e.stopPropagation()}>
        {!forced && <button data-testid="change-password-close" className="icon-btn pw-close" onClick={onClose}><X size={17} /></button>}
        <div className="pw-head">
          <span className="pw-icon"><KeyRound size={20} /></span>
          <p className="eyebrow">KEAMANAN AKUN</p>
          <h2>{forced ? "Buat kata sandi baru" : "Ganti kata sandi"}</h2>
          <p className="pw-sub">{forced ? "Anda masuk dengan kata sandi sementara. Demi keamanan, buat kata sandi baru sebelum mulai bekerja." : "Masukkan kata sandi Anda saat ini lalu tentukan kata sandi baru."}</p>
        </div>
        <div className="pw-body">
          {error && <div className="journal-balance bad" data-testid="change-password-error">{error}</div>}
          {fields.map((f) => (
            <label key={f.key} className="pw-field">
              <span>{f.label}</span>
              <div className="pw-input-wrap">
                <input data-testid={f.testid} type={show ? "text" : "password"} value={form[f.key]} placeholder={f.ph}
                  onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} />
              </div>
            </label>
          ))}
          <button type="button" data-testid="toggle-show-password" className="pw-show" onClick={() => setShow(!show)}>
            {show ? <EyeOff size={13} /> : <Eye size={13} />} {show ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
          </button>
          <div className="pw-hint"><ShieldCheck size={14} /> Gunakan minimal 8 karakter — kombinasi huruf, angka, dan simbol lebih aman.</div>
        </div>
        <div className="pw-foot">
          <button data-testid="change-password-save" className="primary-btn pw-save" disabled={!form.old_password || !form.new_password || !form.confirm || saving} onClick={submit}>{saving ? "Menyimpan..." : "Simpan kata sandi baru"}</button>
          {!forced && <button data-testid="change-password-cancel" className="pw-logout" onClick={onClose}>Batal</button>}
          {forced && onLogout && <button data-testid="change-password-logout" className="pw-logout" onClick={onLogout}><LogOut size={13} /> Keluar dan masuk dengan akun lain</button>}
        </div>
      </div>
    </div>
  );
};
